import { CA885PaymentScenariosModel } from '../../disclosure/models/loan-application.model';
import { AntiSteering } from './anti-steering.model';
import { OriginationChannel } from './origination-channel.enum';

export class ReferralInfoModel {
  referralCompany?: string;
  referralPartner?: string;
  referralContactName?: string;
  referralContactNumber?: string;
  referralEmailAddress?: string;
  referralType?: string;
  relocationSourceType?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  referralCityId?: number = 0;
  referralStateId?: number = 0;
  referralStreetId?: number = 0;
  referralZipId?: number = 0;
  referralCompanyId?: number = 0;
  referralContactNameId?: number = 0;
  referralContactNumberId?: number = 0;
  referralEmailId?: number = 0;
  referralTypeId?: number = 0;
  referralPartnerMsaId?: number = 0;
  referralPartnerDeskRentalId?: number = 0;
  referralPartnerLeadshareId?: number = 0;
}
export class HouseholdMemberModel {
  age?: number = null;
  disabled?: boolean = false;
  fullTimeStudent?: boolean = false;
  houseHoldMemberName?: string = '';
  receivesIncome?: boolean = false;
  sourceIncome?: string = '';
  houseHoldMemberNameId?: number = null;
  ageId?: number = null;
  fullTimeStudentId?: number = null;
  disabledId?: number = null;
  receivesIncomeId?: number = null;
  sourceIncomeId?: number = null;
  isDeleted?: boolean = false;
}

export class LoanInfoCombinedHousingExpenseModel {
  firstMortgageProposed?: number;
  grossTotalIncome?: number;
  hazardInsuranceProposed?: number;
  hoaDuesPaymentProposed?: number;
  mortgageInsuranceProposed?: number;
  otherProposed?: number;
  otherFiPaymentProposed?: number;
  proposedTotal?: number;
  realEstateTaxProposed?: number;
}

export interface RelatedLoanModel {
  affordableLoan?: boolean;
  creditorName?: string;
  fundsSourceType?: number;
  helocCreditLimit?: number;
  isConcurrentlyClosing?: boolean; //isConcurrent?: boolean;
  isHeloc?: boolean;
  lienPriorityType?: LienPriorityType; //lienType?: string;
  balanceAtClosing?: number; //loanAmount?: number;
  monthlyPayment?: number;
  relatedLoanId?: number;
  isDeleted?: boolean;
  intRate?: number;
  loanMaturityPeriodCount?: number;
}

export enum LienPriorityType {
  notAssigned = 0,
  first = 1,
  second = 2,
  third = 3,
  forth = 4,
}

export class LoanPropertyFeeWorksheetModel {
  afterImprovedValue?: string;
  amortizationTypeDescOV?: string;
  applicationDeposit?: number;
  appraisalProductName?: string;
  appraisedValue?: number;
  apr?: number;
  baseLoan?: number;
  borrowerCityName?: string;
  borrowerFullName?: string;
  borrowerPostalCode?: string;
  borrowerStateName?: string;
  borrowerStreet?: string;
  caseNoAssignmentPeriod?: number;
  cemaLoan?: boolean;
  cemaPreviousCmgLoanNumber?: {
    id: number;
    value: string;
  };
  cemaInternalCollateralReqDate?: {
    id: number;
    value: Date;
  };
  cemaCollateralReqFromCustodianDate?: {
    id: number;
    value: Date;
  };
  cltv?: number;
  currentLender?: string;
  currentUnpaidPrincipleBalanceamount?: number;
  daysOfPerDiem?: number;
  discount?: number;
  downPaymentAmount?: number;
  downPaymentPercentage?: number;
  dpfactor?: string;
  earnestMoneyDeposit?: number;
  estClosingDateStringFormat?: string;
  everHadVALoan?: number;
  existingSecondLien?: number;
  fileCreditScore?: number;
  finalOrReinspection1004dRequired?: boolean;
  fundingFeeType?: number;
  inProcessingDate?: string;
  interestOnlyPeriod?: string;
  intRate?: number;
  isJumbo?: boolean;
  isLoanANewConstruction?: boolean;
  isPropertyTBD?: boolean;
  jumboRequiredSecondAppraisal?: boolean;
  lienPosition?: string;
  loanEstimatedClosingDate?: string;
  loanProductType?: number;
  loanProgramCode?: string;
  loanProgramName?: string;
  loanPurpose?: number;
  loanPurposeOther?: string;
  loanWith?: number;
  lockCanceledDate?: string;
  lockExpirationDate?: string;
  lockFloating?: boolean;
  lockStartDate?: string;
  loCommunicationToDisclosuresAmcValue?: number;
  ltv?: number;
  miPaidInCash?: number;
  miPFFFinancingCalcOption?: number;
  monthlyMIAmount?: number;
  monthlyMIFactor?: string;
  monthOrYearCurrentLoanWasTaken?: string;
  mortgageType?: number;
  mortgageTypeOther?: string;
  noOfUnits?: number;
  occupancy?: number;
  originalPrincipalOfCurrentLoan?: number;
  pmiType?: number;
  property?: number;
  refiPurpAU?: number;
  refiTypeFHA?: number;
  refiTypeVA?: number;
  rushAppraisal?: boolean;
  salesPrice?: number;
  sectionOfAct?: number;
  sizeInAcres?: number;
  specialFloodHazardArea?: boolean;
  subordinateAmount?: number;
  subPropCityName?: string;
  subPropCounty?: string;
  subPropCountyFips?: string;
  subPropPostalCode?: string;
  subPropStateFips?: string;
  subPropStateName?: string;
  subPropStreet?: string;
  term?: number;
  townShip?: string;
  upfrontMiAmount?: number;
  upfrontMIFactor?: string;
  upfrontMiType?: string;
  veteranHasDisability?: number;
  waiveEscrow?: number;
  yearCurrentPropertyWasPurchased?: string;
}

export class LoanDataModel {
  addlProdAssistant?: AddlProdAssistantModel;
  addlProdAssistant2?: AddlProdAssistantModel;
  address?: string;
  afterImprovedValue?: string;
  agencyCaseNumber?: string;
  aioCashInHand?: number;
  aioCashInHandId?: number;
  minimumDrawAmount?: number;
  aioInitialDrawAmount?: number;
  aioInitialDrawAmountId?: number;
  aioLoanNotes?: string;
  aioLoanNotesId?: number;
  aioMaxRate?: number;
  aioMaxRateId?: number;
  aioWelcomeLetterRequestDate?: string;
  aioWelcomeLetterRequestDateId?: number;
  amortizationType?: number;
  amortizationTypeDescription?: string;
  antiSteering?: AntiSteering;
  applicationDate?: string;
  appraisalValue?: number;
  apr?: number;
  areYouDisabledVeteran?: boolean;
  armAddFeatures?: string;
  armAdjustCapFirst?: number;
  armAdjustCapSubsequent?: number;
  armCarryover?: boolean;
  armCommonRenewal?: number;
  armConversionOption?: boolean;
  armFloor?: number;
  armHasNegAmFeature?: boolean;
  armIndexNameOV?: string;
  armIndexType?: number;
  armIntRateAdjustAt?: number;
  armIntRateFixedFor?: number;
  armMargin?: number;
  armIndexValue?: number;
  armIndexValueForWeekEnding?: Date;
  armIndexPublished?: string;
  armLifeCap?: number;
  armLookbackDays?: number;
  armNegAmDesc?: string;
  armNoAdjCap?: boolean;
  armRounding?: number;
  armQualRateOption?: number;
  baseLoanAmount?: number;
  borrower1PreferredContactNumber?: number;
  borrower1PreferredContactNumberId?: number;
  borrower2PreferredContactNumber?: number;
  borrower2PreferredContactNumberId?: number;
  cA885PaymentScenario?: CA885PaymentScenariosModel;
  caseNumberAssignedDate?: number;
  channel?: number;
  cltv?: number;
  coBrandedREA?: string;
  coBrandedREAId?: number;
  constructionPurpose?: number;
  creditScoreMedian?: number;
  demandFeature?: boolean;
  downPaymentAmount?: number;
  downPaymentPercentage?: number;
  doYouOwnMoreThan4Dwelling?: number;
  dpfactor?: string;
  dwellingCoveredDetails?: string;
  qualRateReboundLoanNumber?: string;
  qualRateReboundLoanNumberId?: number;
  loanPropertyFeeWorksheet?: LoanPropertyFeeWorksheetModel;
  fhaCity?: string;
  fhaState?: string;
  fhaStreet?: string;
  fhaZip?: string;
  fhaCashOutRefiAcquiredDate?: Date;
  fhaOccupancySeasoningDate?: Date;
  dateOwnedAndOccupied?: Date;
  vaSixMonthlyPaymentDate?: Date;
  fileDataId?: number;
  fileName?: string;
  firstRatio?: number;
  firstPaymentDate?: Date;
  daysOfPerDiem?: number;
  fundingFeeType?: number;
  gusFirstRunDate?: number;
  hasPrepaymentPenalty?: boolean;
  haveYouSoldRealEstateIn60Months?: boolean;
  helocDrawAccessTerm?: number;
  helocRepaymentTerm?: number;
  homeOwnedThroughVa?: number;
  householdMembers?: HouseholdMemberModel[];
  inProcessingDate?: string;
  interestOnlyPeriod?: number;
  interestRate?: number;
  intOnlyQualPaymentCalcOption?: number;
  isBalloon?: boolean;
  isDwellingToBeCovered?: number;
  isInterestOnly?: boolean;
  isItToBeSold?: number;
  isJumbo?: boolean;
  isNegativeAmortization?: boolean;
  isGrantLoan?: boolean;
  halalSFC?: boolean;
  isHomeFundItLoan?: boolean;
  isOther?: boolean;
  isPrepaymentPenalty?: boolean;
  isRateReboundRefinance?: boolean;
  isRateReboundRefinanceId?: number;
  isTemporaryBuydown?: boolean;
  lenderCaseNumber?: string;
  lenderFhaId?: string;
  lenderVaId?: string;
  loanId?: number;
  loanInfoCombinedHousingExpense?: LoanInfoCombinedHousingExpenseModel;
  loanProgramCode?: string;
  loanProgramName?: string;
  loanPurpose?: number;
  loanTerm?: number;
  balloonTerm?: number;
  lockExpirationDate?: string;
  lockStartDate?: string;
  ltv?: number;
  maxDrawAmountNinetyNinePercentOfLoanAmount?: number;
  maxDrawAmountNinetyNinePercentOfLoanAmountId?: number;
  maxLoanLimitByCounty?: number;
  miPaidInCash?: number;
  mipffFinancingCalcOption?: number;
  mipffPercent?: number;
  monthlyMCC?: number;
  monthlyMiAmount?: number;
  monthlyMiFactor?: number;
  monthlyMiFactor2?: number;
  mortgageAppliedFor?: MortgageType;
  organizationId?: number;
  originalMortgageAmount?: number;
  originationChannel?: OriginationChannel;
  otherMortgageDescription?: string;
  otherPurposeDescription?: string;
  pmiType?: number;
  cemaLoan?: {
    id: number;
    value: string;
  };
  cemaPreviousCmgLoanNumber?: {
    id: number;
    value: string;
  };
  cemaInternalCollateralReqDate?: {
    id: number;
    value: Date;
  };
  cemaCollateralReqFromCustodianDate?: {
    id: number;
    value: Date;
  };
  extendedRateLock?: {
    id: number;
    value: boolean;
  };
  prepaymentPenaltyMax?: number;
  prepaymentPenaltyTerm?: number;
  productDescription?: number;
  productDescriptionOther?: string;
  qaCallComplete?: string;
  qaCallCompleteId?: number;
  qaCallRequest?: string;
  qaCallRequestId?: number;
  pi?: number;
  piti?: number;
  qualPi?: number;
  qualPiId?: number;
  qualPiti?: number;
  qualPitiId?: number;
  qualRate?: number;
  qualRateOV?: number;
  referralInfo?: ReferralInfoModel;
  refinancePurposeAu?: number;
  refinancePurposeFha?: number;
  refinancePurposeVa?: number;
  relatedLoans?: RelatedLoanModel[];
  salesPrice?: number;
  schedClosingDate?: Date;
  signingAppointmentDate?: Date;
  signingAppointmentTime?: string;
  schedFundingDate?: Date;
  secondRatio?: number;
  sectionOfAct?: number;
  soldSalesPriceFha?: number;
  sponsorFhaid?: string;
  sponsorVaid?: string;
  statusId?: number;
  subOrdinateFinance?: SubordinateFinanceModel;
  totalLoanAmount?: number;
  totalMOnthlyPayments?: number;
  unusedFundsLeftOnCreditLine?: number;
  unusedFundsLeftOnCreditLineId?: number;
  upfrontMiAmount?: number;
  upfrontMiFactor?: number;
  upfrontMiType?: string;
  userId?: number;
  earnestAmt?: number;
  sellerCredit?: number;
  OpsLenderCredit?: number;
  vaSplitFee?: boolean;
  vaSplitFeeID?: number;
  fhaExpectedEndorsementDate?: Date;
  fhaPreviousEndorsementDate?: Date;
  //  Added
  readonly upfrontMiAmountId?: number;
  readonly downPaymentAmountId?: number;
  readonly downPaymentPercentageId?: number;
  readonly dpFactorId?: number;
  readonly upfrontMiTypeId?: number;
  readonly fHA203KId?: number;
  readonly fHAMCAWId?: number;
  readonly primaryApplicationId?: number;
  readonly primaryBorrowerId?: number;
  readonly pricedProductName?: string;
  readonly timePriced?: string;
  readonly totalMonthlyPayments?: number;
  propertyState?: string;
  texasA6Status?: number;
  isSandboxLoan?: boolean;
  sandboxName?: string;
  maxNumberSandboxAllowed?: number;
  isCrossBusinessEntity?: boolean;
  expandedGuidelines?: {
    bankruptcyOutcome?: number;
    bankruptcySeasoning?: number;
    bankruptcyType?: number;
    debtConsolidation?: boolean;
    dscr?: number;
    housingEventSeasoning?: number;
    housingEventType?: number;
    incomeVerificationType?: number;
    timesMortPmntLateBy30DaysInLast1To12Mos?: number;
    timesMortPmntLateBy60DaysInLast1To12Mos?: number;
    timesMortPmntLateBy90DaysInLast1To12Mos?: number;
    timesMortPmntLateBy120DaysInLast1To12Mos?: number;
    timesMortPmntLateBy30DaysInLast13To24Mos?: number;
    timesMortPmntLateBy60DaysInLast13To24Mos?: number;
    timesMortPmntLateBy90DaysInLast13To24Mos?: number;
    timesMortPmntLateBy120DaysInLast13To24Mos?: number;
    uniqueProperty?: boolean;
  };
}

export interface AddlProdAssistantModel {
  id?: number;
  value?: string;
}

export class LoanFeaturesModel {
  isBalloon: boolean;
  isInterestOnly: boolean;
  isNegativeAmortization: boolean;
  isPrepaymentPenalty: boolean;
  isRateReboundRefinance?: boolean;
  hasPrepaymentPenalty: boolean;
  prepaymentPenaltyMax: number;
  prepaymentPenaltyTerm: number;
  isTemporaryBuydown: boolean;
  isOther: boolean;
  qualRateReboundLoanNumber?: string;
  productDescription: number;
  productDescriptionOther: string;
  cemaLoan?: {
    id: number;
    value: string;
  };
  cemaPreviousCmgLoanNumber?: {
    id: number;
    value: string;
  };
  cemaInternalCollateralReqDate?: {
    id: number;
    value: Date;
  };
  cemaCollateralReqFromCustodianDate?: {
    id: number;
    value: Date;
  };
  extendedRateLock?: {
    id: number;
    value: boolean;
  };
  halalSFC?: boolean;
}

export class ExpandedGuidelinesModel {
  timesMortPmntLateBy30DaysInLast1To12Mos: number;
  timesMortPmntLateBy30DaysInLast13To24Mos: number;
  timesMortPmntLateBy60DaysInLast1To12Mos: number;
  timesMortPmntLateBy60DaysInLast13To24Mos: number;
  timesMortPmntLateBy90DaysInLast1To12Mos: number;
  timesMortPmntLateBy90DaysInLast13To24Mos: number;
  timesMortPmntLateBy120DaysInLast1To12Mos: number;
  timesMortPmntLateBy120DaysInLast13To24Mos: number;
  incomeVerificationType: number | null;
  dscr: number | null;
  uniqueProperty: boolean;
  debtConsolidation: boolean;
  bankruptcyType: number | null;
  bankruptcyOutcome: number | null;
  bankruptcySeasoning: number | null;
  housingEventType: number | null;
  housingEventSeasoning: number | null;
}

export class SubordinateFinanceModel {
  calculatedPi: number;
  dotId: number;
  excludeSubFi: boolean;
  hcltv: number;
  helocMaxBalance: number;
  subFiBaseLoan: number;
  subFiIntOnly: boolean;
  subFiIntRate: number;
  subFiTerm: number;
  subFiType: SubFiType; // enum SubFiTypes;
}

export class LoanInfoRequest {
  loanPurpose = '';
  mortgageType = 0;
  loanProgramCode = '';
  fundingFeeType = 0;
  downPayment = 0;
  salesPrice = 0;
  baseLoan = 0;
  upfrontMiType = '';
  mipffFinancingCalcOption = 0;
  upfrontMiAmount = 0;
  downPaymentPercent = 0;
  dpFactor = '';
  principleAndInterest = 0;
  proposedCombinedHousingExpenses = 0;
  grossMonthlyIncome = 0;
  totalMonthlyPayment = 0;
  monthlyMCC = 0;
  appraisalValue = 0;
  subordinateFinanceAmount = 0;
  hellocCreditLimit = 0;
  loanTerm = 0;
  balloonTerm?: number = null;
  interestRate = 0;
  fhaCaseNoAssigned: number = null;
  monthlyMiFactor = 0;
  upfrontMiFactor = 0;
  occupancyType = 0;
  PresentCombinedHousingExpenses = 0;
  schedClosingDate?: Date = null;
}
export class LoanInfoRequestGvtFundingFactors {
  loanPurpose = '';
  mortgageType = 0;
  loanProgramCode = '';
  fundingFeeType = 0;
  downPayment = 0;
  salesPrice = 0;
  baseLoan = 0;
  upfrontMiType = '';
  mipffFinancingCalcOption = 0;
  upfrontMiAmount = 0;
  downPaymentPercent = 0;
  dpFactor = '';
  principleAndInterest = 0;
  proposedCombinedHousingExpenses = 0;
  grossMonthlyIncome = 0;
  totalMonthlyPayment = 0;
  monthlyMCC = 0;
  appraisalValue = 0;
  subordinateFinanceAmount = 0;
  hellocCreditLimit = 0;
  loanTerm = 0;
  balloonTerm?: number = null;
  interestRate = 0;
  fhaCaseNoAssigned: number = null;
  monthlyMiFactor = 0;
  upfrontMiFactor = 0;
  occupancyType = 0;
  PresentCombinedHousingExpenses = 0;
  schedClosingDate?: Date = null;
  totalLoanAmount?: number = null;
  monthlyMiAmount = 0;
}

export class LoanInfoResponse {
  baseLoan = 0;
  upfrontMiFactor = 0;
  upfrontMiAmount = 0;
  mipPaidInCash = 0;
  noteLoanAmount = 0;
  firstRatio = 0;
  secondRatio = 0;
  ltv = 0;
  cltv = 0;
  hcltv = 0;
  firstMortgagePI = 0;
  monthlyMiAmount = 0;
  monthlyMiFactor = 0;
  piti = 0;
}

export class LoanInfoResponse2 {
  baseLoan = 0;
  firstRatio = 0;
  secondRatio = 0;
  ltv = 0;
  cltv = 0;
  hcltv = 0;
  firstMortgagePI = 0;
  piti = 0;
}

export class LtvCltvHcltvResponse {
  ltv = 0;
  cltv = 0;
  hcltv = 0;
}

export interface RHSFactorMatrix {
  usdaCaseNoAssigned: number;
  mipFactor: number;
  upfrontMiFactor: number;
  isRefinance: boolean;
}

export interface FHAFactorMatrix {
  fhaCaseNoAssigned: number;
  mipFactor: number;
  ltvGreaterThanLimit: boolean;
}

export interface RHSFactorMatrix {
  usdaCaseNoAssigned: number;
  mipFactor: number;
  upfrontMiFactor: number;
  isRefinance: boolean;
}

export interface loanInfoResponse {
  baseLoan: number;
  upfrontMiFactor: number;
  upfrontMiAmount: number;
  mipPaidInCash: number;
  noteLoanAmount: number;
  firstRatio: number;
  secondRatio: number;
  ltv: number;
  cltv: number;
  hcltv: number;
  firstMortgagePI: number;
  monthlyMiFactor: number;
  monthlyMiAmount: number;
  piti: number;
}

export enum ARMQualRateOption {
  NotAssigned = 0,
  NoteRate = 1,
  MaxRateInFirst5Years = 2,
  RatePlus2OrFIR = 3,
  RateOrFIR = 4,
  RatePlus1 = 5,
  RatePlus2OrRoundedFIR = 6,
  RateOrRoundedFIR = 7,
}

export enum IntOnlyQualPaymentCalcOption {
  Default = 0,
  AmortizingOverFullTerm = 1,
  AmortizingOverNonInterestOnlyTerm = 2,
  InterestOnly = 3,
}

export enum LoanPurposeType {
  notAssigned = 0,
  purchase = 1,
  refinance = 2,
  construction = 3,
  constructionPerm = 4,
  second = 5,
  third = 6,
  purchaseMoneySecond = 7,
  other = 8,
  purchaseMoneyThird = 9,
  refiSecond = 10,
  refiThird = 11,
}

export enum RefiTypeVA {
  notAssigned = 0,
  IRRR = 1,
  other = 2,
}

export enum RefiTypeFHA {
  NotAssigned = 0,
  StreamlinedWithAppraisal = 1,
  StreamlinedWithoutAppraisal = 2,
  NoCashOut = 3,
  CashOut = 4,
  SimpleRefinance = 5,
}

export enum MortgageType {
  notAssigned = 0,
  va = 1,
  fha = 2,
  conventional = 3,
  usda = 4,
  other = 5,
  heloc = 6,
  stateAgency = 7,
  localAgency = 8,
}
export enum UpfrontMiType {
  select = '',
  financed = 0,
  notfinanced = 1,
}
export enum PurposeOfLoan {
  select = 0,
  purchase = 1,
  refinance = 2,
  construction = 3,
  constructionPerm = 4,
  second = 5,
  third = 6,
  purchaseMoneySecond = 7,
  other = 8,
  purchaseMoneyThird = 9,
  refiSecond = 10,
  refiThird = 11,
}

export enum PmiType {
  select = null,
  none = 1,
  monthly = 0,
  standard = 3,
  singlePremRefund = 4,
  singlePremNonRefund = 5,
  lenderPaid = 7,
  splitPremNonRefund = 8,
}

export enum MICompany {
  archMI = 0,
  quoteWithEligibility = 1,
  enact = 2,
  mgic = 3,
  nationalQuoteWithEligiblity = 4,
  radian = 5,
}

export enum LetterType {
  select = 0,
  preApproval = 1,
  preQualification = 2,
  gift = 3,
  preliminaryPreApproval = 4,
  creditUnderwritingApproval = 5,
}

export enum SectionOfAct {
  select = 0,
  _203b = 1,
  _203_b_2 = 2,
  _203_b_251 = 3,
  _203_k = 4,
  _221_d_2 = 5,
  _221_d_2_251 = 6,
  _234_c = 7,
  _234_c_251 = 8,
  _184 = 9,
}

export enum FundingFeeType {
  select = 0,
  regularMilitaryFirstUse = 1,
  regularMilitarySubequentUse = 2,
  reservesOrGuardFirstUse = 3,
  reservesOrGuardSubsequentUse = 4,
  interestRateReductionRefi = 5,
  manufacturedHome = 6,
  loanAssumption = 7,
  exempt = 8,
}

export enum DpFactorType {
  select = 'Select, Enter Base Loan',
  downpaymentPercentage = 'Downpayment Percentage (%)',
  downpaymentAmount = 'Downpayment Amount ($)',
}

export enum StoreProperty {
  qualRate = 0,
  monthlyMiAmount = 1,
  upfrontMiAmount = 2,
  upfrontMiFactor = 3,
  totalLoanAmount = 4,
  monthlyMiFactor = 5,
  loanProgramName = 6,
  amortizationType = 7,
  interestOnlyPeriod = 8,
  isJumbo = 9,
  fundingFeeType = 10,
  loanTerm = 11,
  loanProgramCode = 12,
  caseNumberAssignedDate = 13,
  rhsCaseNoAssignmentPeriod = 14,
  pmiType = 15,
  upfrontMiType = 16,
  mipffFinancingCalcOption = 17,
  miPaidInCash = 18,
  interestRate = 19,
  baseLoanAmount = 20,
  amortizationTypeDescription = 21,
  loanPurpose = 22,
  isInterestOnly = 23,
  armQualRateOption = 24,
  intOnlyQualPaymentCalcOption = 25,
  earnestMoneyAmount = 26,
  sellerCredit = 27,
  balloonTerm = 28,
  monthlyMiFactor2 = 29,
  texasA6Status = 30,
}

export enum SubFiType {
  notAssigned = 0,
  notHeloc = 1,
  heloc = 3,
}

export interface loanStatusInfo {
  statusID?: number;
  loanStatus?: number;
  leadDate?: Date;
  applicationDate?: Date;
  followUpFlag?: number;
  prequalDate?: Date;
  creditOnlyDate?: Date;
  inProcessingDate?: Date;
  submittedDate?: Date;
  approvedDate?: Date;
  resubmittedDate?: Date;
  declinedDate?: Date;
  inClosingDate?: Date;
  closedDate?: Date;
  canceledDate?: Date;
  schedClosingDate?: Date;
  schedApprovalDate?: Date;
  signingDate?: Date;
  GFEDeliveryMethod?: number;
  GFEDeliveryDate?: Date;
  GFERevisionDate?: Date;
  fundingDate?: Date;
  purchaseContractDate?: Date;
  excludeFromManagementReports?: boolean;
  followUpDate?: Date;
  creditFirstIssuedDate?: Date;
  suspendedDate?: Date;
  docsSignedDate?: Date;
  schedFundingDate?: Date;
  customStatus1Date?: Date;
  customStatus2Date?: Date;
  customStatus3Date?: Date;
  customStatus4Date?: Date;
  customStatus5Date?: Date;
  customStatus6Date?: Date;
  customStatus7Date?: Date;
  customStatus8Date?: Date;
  customStatus9Date?: Date;
  customStatus10Date?: Date;
  customStatus11Date?: Date;
  otherDate1?: Date;
  otherDate2?: Date;
  otherDate3?: Date;
  notes?: string;
  loanPurchasedDate?: Date;
  GFERevisionMethod?: number;
  disclosureWaitingPeriodWaived?: boolean;
  redisclosureWaitingPeriodWaived?: boolean;
  TILRevisionDate?: Date;
  TILRevisionMethod?: number;
  recissionDate?: Date;
  investorDueDate?: Date;
  shipByDate?: Date;
  clearToCloseDate?: Date;
  shippedDate?: Date;
  collateralSentDate?: Date;
  docsSentDate?: Date;
  noteDate?: Date;
  NMLSActionDate?: Date;
  predProtectResult?: number;
  statusDate?: Date;
  complianceEaseRiskIndicator?: number;
  complianceCheckRunDate?: Date;
  complianceCheckOverride?: boolean;
  appraisalCompleted?: Date;
  appraisalDelivered?: Date;
  appraisalDeliveryMethod?: number;
  appraisal2Completed?: Date;
  appraisal2Delivered?: Date;
  appraisal2DeliveryMethod?: number;
  appraisalReceivedByBorrower?: Date;
  appraisal2ReceivedByBorrower?: Date;
  appraisalTimingWaiverDate?: Date;
  docsBackDate?: Date;
  docsImagedDate?: Date;
  investorPackagedDate?: Date;
  investorShippedDate?: Date;
  investorSuspendedDate?: Date;
  investorClearedDate?: Date;
  insurancePackagedDate?: Date;
  insuranceShippedDate?: Date;
  insuranceRejectedDate?: Date;
  insuranceResubmittedDate?: Date;
  insuranceObtainedDate?: Date;
  insuranceRHSRequestMailedDate?: Date;
  insuranceRHSResponseDate?: Date;
  insuranceFeeDeliveredDate?: Date;
  insuranceMIC_LGCToInvestorDate?: Date;
  servicingFirstPaymentDate?: Date;
  servicingDataSentDate?: Date;
  servicingPackageSentDate?: Date;
  servicingAuditDate?: Date;
  servicingAuditUserName?: string;
  corrPurchaseByDate?: Date;
  corrOriginalNoteReceivedDate?: Date;
  insuringReceivedDate?: Date;
  insuranceReviewReqDate?: Date;
  mortRecChangeDate?: Date;
  caseTransferReqDate?: Date;
  caseTransferCompDate?: Date;
  insuringNotes?: string;
  shippingReceivedDate?: Date;
  collateralPackSentDate?: Date;
  finalHUDToInvestorDate?: Date;
  noteShipmentReqDate?: Date;
  noteBackToWarehouseDate?: Date;
  shippingNotes?: string;
  PMICertificateActivationDate?: Date;
  preapprovalApplicationDate?: Date;
  NMLSApplicationDate?: Date;
  CDWaitingPeriodWaived?: boolean;
  intentToProceedDate?: Date;
  closingCostsExpirationDate?: Date;
  closingCostsExpirationTimeOfDayOV?: string;
  CDDateIssuedOption?: number;
  CDDateIssuedOtherDate?: Date;
  hasSixAppDataPoints?: boolean;
  applicationTestResult?: number;
  feeReconciliationTestResult?: number;
  TRIDDisclosureTestResult?: number;
  LEDisclosureTestResult?: number;
  CDDisclosureTestResult?: number;
  closingCostsExpirationTimeZoneCityOV?: number;
  customStatus12Date?: Date;
  customStatus13Date?: Date;
  customStatus14Date?: Date;
  customStatus15Date?: Date;
  customStatus16Date?: Date;
  customStatus17Date?: Date;
  customStatus18Date?: Date;
  customStatus19Date?: Date;
  customStatus20Date?: Date;
  customStatus21Date?: Date;
  customStatus22Date?: Date;
  customStatus23Date?: Date;
  customStatus24Date?: Date;
  customStatus25Date?: Date;
  customStatus26Date?: Date;
  customStatus27Date?: Date;
  customStatus28Date?: Date;
  customStatus29Date?: Date;
  customStatus30Date?: Date;
  signingAppointmentConfirmed?: boolean;
  signingAppointmentLocationType?: number;
  signingAppointmentTime?: string;
  signingAppointmentDate?: Date;
  lastStatusChangeDateTime?: Date;
  eSignTestResult?: number;
  MERSRegistrationDate?: Date;
  MERSTransferDate?: Date;
  MERSCurrentInvestorOrgID?: string;
  MERSCurrentServicerOrgID?: string;
  MERSCurrentSubservicerOrgID?: string;
  interimIntAdditionalConsentedDays?: number;
  NMLSApplicationDateCalcOption?: number;
  fileDataID?: number;
}
